module.exports = "/build/web/svg/social/small/retweet.6b2e93dd7822d603fb4906f22c961ae7.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/retweet.svg
// module id = 116
// module chunks = 24